import { Button } from '@packages/shared/src/ui/Button/Button';
import { useIntl } from 'react-intl';
import { actionButtonMessages } from './messages';

export type ActionButtonProps = {
  type: 'Decrease' | 'Increase';
  onClick: () => void;
  disabled: boolean;
  height: string;
  step: number;
};

export const ActionButton = ({ type, onClick, disabled, height, step }: ActionButtonProps) => {
  const { formatMessage } = useIntl();

  return (
    <Button
      onClick={onClick}
      disabled={disabled}
      aria-label={formatMessage(
        type === 'Decrease' ? actionButtonMessages.decrease : actionButtonMessages.increase,
        { step },
      )}
      className="min-h-0 p-0"
      style={{
        height,
        width: height,
      }}
    >
      <span
        className={`${type === 'Decrease' ? 'icon-emp-minus' : 'icon-emp-plus'} ${disabled && 'opacity-50'}`}
      />
    </Button>
  );
};
